import React, { useMemo } from 'react'
import { IcoMoon, Box, KeyboardArrowRightIcon } from '@usap/uicomponents'
import { LastLinkTextWithStyle, LinkStyle, BreadcrumbsTextWithStyle, BreadCrumbBox } from './style/Breadcrumbs.css'
import useBreadcrumbClickHandlers from './hooks/useBreadcrumbClickHandlers'
import BreadcrumbWMO from './BreadcrumbWMO'
import useIsWmoEnabled from '@usap/carparts/src/shared/hooks/useWmoEnabled'

const style = {
  margin: {
    topMargin: {
      top: '16px', bottom: '0px', left: 'auto', right: 'auto',
    },
    vertical: '16px',
    horizontal: 'auto',
  },
  pad: {
    small: { horizontal: 'small' },
    xsmall: { horizontal: 'xsmall' },
    large: { horizontal: '16px' },
  },
  width: "1248px"
}

const CheckForLastLink = props => {
  const {
    Link, useLastLinkFlag, item, maxLength,
  } = props

  return useLastLinkFlag
    ? (
      <Link
        to={item.link || item.url || item.value}
        style={LinkStyle}
      >
        <LastLinkTextWithStyle
          noPointer={maxLength}
          as={maxLength ? 'strong' : 'normal'}
        >
          {item.name || item.text}
        </LastLinkTextWithStyle>
      </Link>
    )
    : (
      <LastLinkTextWithStyle
        as={maxLength ? 'strong' : 'normal'}
        noPointer={maxLength}
      >
        {item.name || item.text}
      </LastLinkTextWithStyle>
    )
}

export default function Breadcrumb({
  id = 'breadcrumb',
  links = [],
  Link = () => '',
  useLastLinkFlag = false,
  isScroll = true,
}) {
  const isWmoEnabled = useIsWmoEnabled()
  const clickHandlers = useBreadcrumbClickHandlers(links)

  if (typeof links[2] !== 'undefined' && links[2].text === 'Order Details') {
    return null
  }

  const { length } = links

  if(isWmoEnabled) {
    return (<BreadcrumbWMO
      id={id}
      links={links}
      Link={Link}
      useLastLinkFlag={useLastLinkFlag}
    />)
  }

  return (
    <Box id={`${id}-wrapper`} width={style.width} margin={{vertical:"0px", horizontal:'auto'}}>
      <BreadCrumbBox
       id="breadCrumbList"
        as="ul"
        width="1248px"
        className={isScroll ? "breadCrumbListScrollable" : ''}
      >
        {links.map((item, index) => {
          const maxLength = length === index + 1

          return (
            <Box
              id={(item.name || item.text).replace(/ /g, '')}
              key={item.name || item.text}
              as="li"
              direction="row"
              align="center"
              justify="center"
            >
              {maxLength
                ? (
                  <CheckForLastLink
                    Link={Link}
                    useLastLinkFlag={useLastLinkFlag}
                    item={item}
                    maxLength={maxLength}
                  />
                )
                : (
                  <Link
                    to={item.link || item.url || item.value}
                    aria-label={item.name || item.text}
                    style={LinkStyle}
                    onClick={clickHandlers[index]}
                  >
                    <BreadcrumbsTextWithStyle
                      textAlign="center"
                      color="dark-2"
                      weight={maxLength ? 'bold' : 'normal'}
                      noPointer={maxLength}
                      size="xsmall"
                      itemProp="name"
                      content={item.name || item.text}
                    >
                      {item.name || item.text}
                    </BreadcrumbsTextWithStyle>
                  </Link>
                )}

              {!maxLength && (
                <Box pad={style.pad.xsmall}>
                  <IcoMoon
                    icon={KeyboardArrowRightIcon}
                    color="dark-2"
                    size="20px"
                  />
                </Box>
              )}
            </Box>
          )
        })}
      </BreadCrumbBox>
    </Box>
  )
}
